module.exports = __webpack_public_path__ + "img/orange_097.c21585dd.png";